const EnterpriseFeatures = {
  RBAC: 'RBAC',
  SSO: 'SSO',
  TEAMS: 'TEAMS',
  SUPPORT: 'SUPPORT',
  AUDIT_LOG: 'AUDIT_LOG',
  ENTERPRISE_SETTINGS: 'ENTERPRISE_SETTINGS',
  DATA_SYNC: 'DATA_SYNC',
  BUILDER_SSO: 'BUILDER_SSO',
  BUILDER_NO_BRANDING: 'BUILDER_NO_BRANDING',
  BUILDER_FILE_INPUT: 'BUILDER_FILE_INPUT',
  BUILDER_CUSTOM_CODE: 'BUILDER_CUSTOM_CODE',
  ADVANCED_WEBHOOKS: 'ADVANCED_WEBHOOKS',
  FIELD_LEVEL_PERMISSIONS: 'FIELD_LEVEL_PERMISSIONS',
  DATE_DEPENDENCY: 'DATE_DEPENDENCY',
  DATA_SCANNER: 'DATA_SCANNER',
}

export default EnterpriseFeatures
